import React, { memo } from "react";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  padding-top: 140px;
  background: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};

  @media (max-width: 768px) {
    padding-top: 100px;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0px 30px;

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 0px 50px;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  text-align: left;
  margin-bottom: 70px;
  color: ${(props) => props.theme.colors.black};

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 2rem;
    margin-bottom: 40px;
  }
  @media (max-width: 768px) {
    font-size: 1.7rem;
    margin-bottom: 20px;
  }
`;

const PageContainer = memo(({ children, title }) => {
  return (
    <Container>
      <Content>
        {title && <Title>{title}</Title>}
        {children}
      </Content>
    </Container>
  );
});

PageContainer.displayName = "PageContainer";

export default PageContainer;
